import { ApiClient } from '@/api/client';

const client = new ApiClient('/api/v1/accounts');

export default {
  /**
   * Get a list of Accounts
   */
  getAccounts: (queryParams = {}) =>
    client
      .get('', { params: queryParams })
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error.response)),

  /**
   * Get an Account
   */
  getAccount: (accountId, queryParams = {}) => client.get(`/${accountId}`, { params: queryParams }),

  /**
   * Store a new Account
   */
  storeAccount: (accountData) =>
    client
      .post('', accountData)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error.response)),

  /**
   * Update an Account
   */
  updateAccount: (accountId, accountData) =>
    client
      .put(`/${accountId}`, accountData)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error.response)),

  /**
   * Update a Accounts' cover
   */
  updateAccountCover: (accountId, formData, config) =>
    client.post(`/${accountId}/cover`, formData, config),

  /**
   * Delete an Account
   */
  deleteAccount: (accountId) => client.delete(`/${accountId}`),
};
